module.exports = __webpack_public_path__ + "static/img/mens_art_camp.7a4bd7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_art_camp.svg
// module id = WJYC
// module chunks = 0